import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import { useContext } from 'react';

import Button from '@/contents/General/Button';
import Icon from '@/contents/General/Icon';
import { Board } from '@/contents/General/Panels';
import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import { GlobalContext } from '@/contents/hooks/state';
import useGetLoginUser from '@/modules/User/user/useGetLoginUser';
import theme from '@/styles/theme';

const BeforeEditInfo = ({ campSiteId }: { campSiteId: string }) => {
  const router = useRouter();
  const { dialogStatus, setDialogStatus } = useContext(GlobalContext);
  const { isLogin } = useGetLoginUser();

  const nextPage = (path: string) => {
    setDialogStatus({ ...dialogStatus, open: false });
    if (isLogin) {
      router.push(path);
      return;
    }
    router.push(`/login`);
  };

  return (
    <Board sx={{ padding: theme.spacing(3) }}>
      <Box>
        <Typography fontSize={16} fontWeight={700} paddingBottom={2}>
          キャンプ場情報を記入・編集していただきありがとうございます。
        </Typography>
        <Typography fontSize={15}>
          入力・設定項目が複数ありますが、わからないところは未入力・未設定のままでも大丈夫です。
          キャンプ場情報の拡充へのご協力を、引き続きよろしくお願いいたします！
        </Typography>
        <Stack center padding={4}>
          <Button
            onClick={() => nextPage(`/camp/${campSiteId}/edit`)}
            buttonSize="md"
            color="secondary"
            sx={{
              width: '246px',
            }}
          >
            基本情報の編集に進む
          </Button>
        </Stack>
        <Stack column space={2}>
          <Stack
            onClick={() => nextPage('/guideline')}
            sx={{ cursor: 'pointer' }}
          >
            <Icon iconType="arrow-right" color="primary" />
            <Typography fontSize={14} fontWeight={700} color="primary">
              コミュニティガイドラインを確認する
            </Typography>
          </Stack>
          <Stack
            onClick={() =>
              nextPage('/contact/user?category=キャンプ場の閉店申請')
            }
            sx={{ cursor: 'pointer' }}
          >
            <Icon iconType="arrow-right" color="primary" />
            <Typography fontSize={14} fontWeight={700} color="primary">
              キャンプ場の閉店申請はこちら
            </Typography>
          </Stack>
          <Stack
            onClick={() =>
              nextPage('/contact/user?category=キャンプ場名称・住所の編集依頼')
            }
            sx={{ cursor: 'pointer' }}
          >
            <Icon iconType="arrow-right" color="primary" />
            <Typography fontSize={14} fontWeight={700} color="primary">
              施設名・住所の情報編集はこちら
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Board>
  );
};

export default BeforeEditInfo;
